import { __read, __assign } from 'tslib';
import React, { useState } from 'react';
import { NvTooltip, NvSelect, NvButton } from '@invitae/ids-react';
import { CountryOptions } from '@invitae/location-lite-core';
import { useLocationLiteCookie } from './aspects/cookie/hooks.esm.js';
import './aspects/domain/context.esm.js';
import './node_modules/cookie/index.esm.js';
import { LocationLiteIcon } from './icon.esm.js';
import { getCountryOptionByLocale } from './utils/defaults.esm.js';

/**
 * UI control to display the user's detected country, and allow them to override it
 */
var LocationLiteControl = function (_a) {
    var _b = _a.label, label = _b === void 0 ? 'Select your country:' : _b, _c = _a.name, name = _c === void 0 ? 'locationLiteSelector' : _c, _d = _a.options, options = _d === void 0 ? CountryOptions : _d, _e = _a.popoverWidth, popoverWidth = _e === void 0 ? '200px' : _e, btnStyle = _a.btnStyle, btnClass = _a.btnClass, tooltipProps = _a.tooltipProps, _f = _a.displayMode, displayMode = _f === void 0 ? 'countryCode' : _f, _g = _a.theme, theme = _g === void 0 ? 'light' : _g, userLocale = _a.userLocale;
    var _h = __read(useLocationLiteCookie(), 2), cookieContent = _h[0], setCookieContent = _h[1];
    var _j = __read(useState(userLocale), 2), userCountryLocale = _j[0], setUserCountryLocale = _j[1];
    /**
     * Creates a ref to NvTooltip, enabling use of its Handles
     */
    var ref = React.useRef(null);
    function onChange(newCountryCode) {
        /**
         * Immediately close the tooltip when a selection is made
         */
        if (ref.current) {
            ref.current.setIsVisible(false);
        }
        /**
         * Set the cookie value, which also updates the cookie context
         * and the value displayed in the Select
         */
        setCookieContent(__assign(__assign({}, cookieContent), { countryCode: newCountryCode.value, setBy: 'user' }));
        /**
         * if cookie changes, then the selected value should change as well
         */
        setUserCountryLocale(newCountryCode.value);
    }
    /**
     * countryOption includes fallback to empty string, to avoid errors in the initial milliseconds
     * before the cookie is set and loaded
     */
    var localeOptionFromCookie = getCountryOptionByLocale(cookieContent.countryCode, options);
    var localeOptionFromUser = getCountryOptionByLocale(userCountryLocale, options);
    var localeSelected = (localeOptionFromUser === null || localeOptionFromUser === void 0 ? void 0 : localeOptionFromUser.value) ? localeOptionFromUser : localeOptionFromCookie;
    var buttonStyles = __assign({ 
        // When color system exports are available from `ids-sass`, these values should be replaced
        color: theme === 'light' ? '#161616' : '#fff', display: 'flex' }, btnStyle);
    var iconStyles = {
        display: 'inline-block',
        marginRight: displayMode !== 'iconOnly' ? '0.33em' : undefined,
    };
    return (React.createElement(NvTooltip, __assign({ destroyTooltipOnHide: false, overlayContent: React.createElement("div", { style: { minWidth: popoverWidth } },
            React.createElement(NvSelect, { label: label, name: name, onChange: onChange, options: options, value: localeSelected })), ref: ref }, tooltipProps),
        React.createElement(NvButton, { className: btnClass, style: buttonStyles, type: "button", variant: "plain" },
            React.createElement(LocationLiteIcon, { height: "1.25em", style: iconStyles, width: "1.25em" }),
            displayMode === 'countryCode' && React.createElement("span", null, localeSelected === null || localeSelected === void 0 ? void 0 : localeSelected.value),
            displayMode === 'countryName' && React.createElement("span", null, localeSelected === null || localeSelected === void 0 ? void 0 : localeSelected.label))));
};

export { LocationLiteControl };
//# sourceMappingURL=component.esm.js.map
